import React from 'react'
import '.././PopupCommonStyle.css'
import styles from './Style.module.css'
import { BtnClose } from '../../Buttons/BtnClose/BtnClose'
import { BtnSecondary } from '../../Buttons/BtnSecondary'

export const VoucherTermsPopup = ({
  active,
  onClose,
}) => {
  return (
    <div className={`${styles.voucherTermsPopup} popup ${active ? "show" : ""}`}>
        <div className={`${styles.popHeader} popup-header`}>
          {/* <BtnClose
          handleClick={onClose}
          title="Close"
          customClass="closeBtn circled"
          iconColor="#ffffff"
          iconSize={16}
          /> */}
          <h2 className="title">Terms & Conditions</h2>
        </div>
        <div className={`${styles.popupBody} popup-body`}>
          <p>Please read the following terms before purchasing or redeeming this voucher.</p>
          <ul>
            <li>Valid for 12 months from purchase date.</li>
            <li>Redeemable at participating outlets only.</li>
            <li>Non-refundable and non-transferable.</li>
            <li>Cannot be exchanged for cash.</li>
            <li>Appointment booking may be required.</li>
          </ul>
        </div>

        <div className={`${styles.footer} popup-footer`}>
          <BtnSecondary
            label="Close"
            handleClick={onClose}
            customClass="w-100 no-icon"
          />
           {/* <button className={styles.closeButton} onClick={onClose}>
          Close
        </button> */}
        </div>
    </div>
  )
}
